/* SINESTESIA - combo: elegir una segunda prenda y sumarla al carrito junto con la principal */
(function () {
  'use strict';

  var elegido = null;

  function iniciar() {
    var root = document.querySelector('[data-sns-pick]');
    if (!root || root.dataset.snsListo === '1') return;
    root.dataset.snsListo = '1';

    var filas = Array.prototype.slice.call(root.querySelectorAll('[data-row]'));

    function estado() {
      root.setAttribute('data-elegido', elegido ? 'true' : 'false');
    }

    function limpiar(menos) {
      filas.forEach(function (o) {
        if (o === menos) return;
        o.querySelector('[data-check]').checked = false;
        o.setAttribute('data-on', 'false');
        o.querySelector('[data-sizes]').hidden = true;
        Array.prototype.forEach.call(o.querySelectorAll('[data-size]'), function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
      });
    }

    filas.forEach(function (fila) {
      var check = fila.querySelector('[data-check]');
      var cajaTalles = fila.querySelector('[data-sizes]');
      var unico = cajaTalles.getAttribute('data-unico') === 'true';
      var botones = Array.prototype.slice.call(fila.querySelectorAll('[data-size]'));

      botones.forEach(function (btn) {
        btn.addEventListener('click', function () {
          botones.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          elegido = btn.getAttribute('data-variant');
          estado();
        });
      });

      check.addEventListener('change', function () {
        if (check.checked) {
          limpiar(fila);
          elegido = null;
          fila.setAttribute('data-on', 'true');
          var primero = botones.filter(function (b) { return !b.disabled; })[0];
          if (unico) {
            cajaTalles.hidden = true;
            if (primero) elegido = primero.getAttribute('data-variant');
          } else {
            cajaTalles.hidden = false;
            if (primero) primero.click();
          }
        } else {
          fila.setAttribute('data-on', 'false');
          cajaTalles.hidden = true;
          elegido = null;
        }
        estado();
      });
    });

    estado();
  }

  /* Delegado en document y en fase de captura: funciona sin importar el orden
     en que se rendericen el bloque y el boton de agregar al carrito. */
  document.addEventListener(
    'click',
    function (e) {
      if (!elegido) return;
      if (!e.target || !e.target.closest) return;
      var boton = e.target.closest('[name="add"]');
      if (!boton || boton.disabled) return;
      var form = boton.closest('form[action*="/cart/add"]');
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var qtyInput = form.querySelector('[name="quantity"]');
      var cantidad = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
      if (!cantidad || cantidad < 1) cantidad = 1;

      boton.setAttribute('aria-busy', 'true');
      boton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(idInput.value, 10), quantity: cantidad },
            { id: parseInt(elegido, 10), quantity: 1 }
          ]
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          boton.disabled = false;
          boton.removeAttribute('aria-busy');
          form.submit();
        });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();
